import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useResourceDefaultDataContextSafe } from '../../../context/resourceDataContext.js';
import { HeaderWrapper } from '../../components/ModalResourceHeader.js';
import { ExpandedResourceDropdownMenu } from '../../components/ExpandedResourceDropdownMenu.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import FileDisplay from '../../../../../resources/components/FileDisplay.js';

const ResourceContentDefault = () => {
  const { resource, handleDownload } = useResourceDefaultDataContextSafe();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(HeaderWrapper, {
        children: [
          /* @__PURE__ */ jsx(HeaderWrapper.Left, {}),
          /* @__PURE__ */ jsx(HeaderWrapper.Right, {
            children: /* @__PURE__ */ jsx(ExpandedResourceDropdownMenu, {})
          })
        ]
      }),
      /* @__PURE__ */ jsx(Flex, {
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center",
        "data-pan-id-ignore-resource-drag-resize": "xy",
        children: /* @__PURE__ */ jsx(FileDisplay, {
          fileExtension: resource.extension,
          fileName: resource.name || "untitled",
          onClick: handleDownload
        })
      })
    ]
  });
};

export { ResourceContentDefault };
//# sourceMappingURL=ResourceContentStoredFile.js.map
